// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-left-FFiZ7Y {
  min-width: 200px;
  padding: 0 8px;
  position: relative;
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-left-FFiZ7Y .semi-tabs-tab-button.semi-tabs-tab {
  color: rgba(var(--coze-fg-4), var(--coze-fg-4-alpha));
  padding: 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-left-FFiZ7Y .semi-tabs-tab-button.semi-tabs-tab-active {
  background-color: rgba(var(--coze-bg-5), var(--coze-bg-5-alpha));
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-left-FFiZ7Y .semi-tabs-tab-button:hover {
  background-color: rgba(var(--coze-bg-5), var(--coze-bg-5-alpha));
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-left-FFiZ7Y .semi-tabs-tab:focus {
  outline: none;
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-left-FFiZ7Y .semi-tabs-bar-left {
  width: 184px;
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-left-FFiZ7Y .semi-tabs-tab-button.semi-tabs-tab-disabled {
  cursor: default;
  color: rgba(var(--coze-fg-2), var(--coze-fg-2-alpha));
  background-color: rgba(0, 0, 0, 0);
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-left-FFiZ7Y .semi-tabs-bar-button.semi-tabs-bar-left .semi-tabs-tab:not(:last-of-type) {
  margin-bottom: 6px;
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-left-FFiZ7Y .semi-tabs-tab:last-child:before {
  content: none;
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__divider-oymnQH {
  border-right: 1px solid var(--coz-stroke-primary);
  height: 600px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 200px;
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__text-20-_8utJV {
  color: rgba(var(--coze-fg-4), var(--coze-fg-4-alpha));
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__text-16-uXIZtu {
  color: rgba(var(--coze-fg-4), var(--coze-fg-4-alpha));
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-right-JzUPAb {
  padding: 0 8px;
  overflow-y: auto;
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-right-JzUPAb .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__title-jRpMan {
  z-index: 1;
  background-color: rgba(var(--coze-bg-2), var(--coze-bg-2-alpha));
  width: 100%;
  color: rgba(var(--coze-fg-4), var(--coze-fg-4-alpha));
  font-size: 20px;
  line-height: 40px;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  font-weight: 500 !important;
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__container-YqvLb7 {
  width: 100%;
  height: calc(100% - 86px);
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .semi-modal .semi-modal-content {
  max-height: 600px;
  padding-top: 0;
  padding-left: 0;
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .semi-modal .semi-modal-content .semi-modal-body {
  padding-top: 0;
}

.\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .semi-modal-close {
  z-index: 2;
  background-color: rgba(var(--coze-bg-2), 1);
  position: absolute;
  right: 24px;
}

@media screen and (min-height: 760px) {
  .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .semi-modal {
    height: 600px;
  }

  .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-right-JzUPAb {
    height: 574px;
  }
}

@media screen and (max-height: 759px) {
  .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .semi-modal {
    height: calc(100vh - 160px);
  }

  .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM .\\------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-right-JzUPAb {
    height: max(448px, 100vh - 186px);
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile-modal": `------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM`,
	"profileModal": `------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-modal-ikOSZM`,
	"profile-left": `------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-left-FFiZ7Y`,
	"profileLeft": `------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-left-FFiZ7Y`,
	"divider": `------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__divider-oymnQH`,
	"text-20": `------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__text-20-_8utJV`,
	"text20": `------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__text-20-_8utJV`,
	"text-16": `------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__text-16-uXIZtu`,
	"text16": `------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__text-16-uXIZtu`,
	"profile-right": `------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-right-JzUPAb`,
	"profileRight": `------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__profile-right-JzUPAb`,
	"title": `------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__title-jRpMan`,
	"container": `------packages-foundation-account-ui-base-src-hooks-use-account-settings-index-module__container-YqvLb7`
};
export default ___CSS_LOADER_EXPORT___;
